// ⚠️ SECURITY: API keys should NEVER be in client-side code
// The frontend now uses the backend API which handles authentication securely
// Configure your OpenAI API key in backend/.env file instead

const rawBaseUrl = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:5000' : 'https://api.exivis.pro');

// Log configuration in development or if debug is enabled
if (process.env.NODE_ENV !== 'production' || window.location.search.includes('debug=true')) {
  console.log('📡 API Configuration:', {
    hostname: window.location.hostname,
    rawBaseUrl,
    envApiUrl: process.env.REACT_APP_API_URL
  });
}

// Ensure API_BASE_URL is absolute and doesn't end with a slash
const getApiBaseUrl = () => {
  let baseUrl = rawBaseUrl;
  
  // If we're on the production domain and using it as base, 
  // we might need to be explicit about whether we want to call same-domain or not.
  // But for now, let's just ensure it's absolute.
  
  if (baseUrl.startsWith('http')) {
    const result = baseUrl.replace(/\/$/, "");
    if (process.env.NODE_ENV !== 'production' || window.location.search.includes('debug=true')) {
      console.log(`🔍 getApiBaseUrl returning: "${result}"`);
    }
    return result;
  }
  
  // If it's a relative path, use window.location.origin
  const origin = window.location.origin;
  const result = `${origin}${baseUrl.startsWith('/') ? '' : '/'}${baseUrl}`.replace(/\/$/, "");
  return result;
};

export const API_BASE_URL = getApiBaseUrl();

// Log the final URL
if (process.env.NODE_ENV !== 'production' || window.location.search.includes('debug=true')) {
  console.log(`🚀 Final API_BASE_URL: ${API_BASE_URL}`);
}

// Hardcoded fallback for production if the above fails or results in a relative-looking URL
// change this to your actual backend domain
export const BACKEND_URL = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://localhost:5000' : 'https://api.exivis.pro'); 

